var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.2502472px",
    height: "20.2502472px",
    viewBox: "0 0 20.2502472 20.2502472",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Staff-Slide-Out",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar-Staff-Slide-Upgrade-V1",
    transform: "translate(-705.25, -795.4998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(703, 794)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.862,4.487 L18.549,2.799 C19.2813296,2.06667042 20.4686704,2.06667042 21.201,2.799 C21.9333296,3.53132958 21.9333296,4.71867042 21.201,5.451 L10.582,16.07 C10.0533248,16.5983652 9.40136574,16.9867225 8.685,17.2 L6,18 L6.8,15.315 C7.01327752,14.5986343 7.40163482,13.9466752 7.93,13.418 L16.862,4.487 L16.862,4.487 Z",
    id: "Path",
    stroke: "#192340",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,14 L18,18.75 C18,19.9926407 16.9926407,21 15.75,21 L5.25,21 C4.00735931,21 3,19.9926407 3,18.75 L3,8.25 C3,7.00735931 4.00735931,6 5.25,6 L10,6",
    id: "Path",
    stroke: "#192340",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.862,
    y1: 4.487,
    x2: 19.5,
    y2: 7.125,
    id: "Path",
    stroke: "#192340",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilNote);
export default __webpack_public_path__ + "static/media/pencil-note.feb7b8643f42e8ab3540ffe51475d5e5.svg";
export { ForwardRef as ReactComponent };